/*
 * @Descripttion:
 * @FilePath: /mall-wap-vue/src/utils/authority.js
 * @Author: 张兴业
 * @Date: 2020-09-24 11:19:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-11-16 14:19:52
 */
// import decodeJwt from "jwt-decode";

export function setToken(data) {
  if (data && data.access_token) {
    localStorage.setItem("mall-wap-vue-token", data.access_token);
  }
}

export function getToken() {
  return localStorage.getItem("mall-wap-vue-token");
}

export function removeToken() {
  return localStorage.removeItem("mall-wap-vue-token");
}
